import { SlidersHorizontal } from 'lucide-react';
import { CareAdjustmentChoices } from '../components/care-adjustment-choices';
import { CareScenarioCard } from '../components/care-scenario-card';
import { StepFrame } from '../components/step-frame';
import { useCareAdjustments } from '../hooks/use-care-adjustments';
import { useConsumerFlow } from '../hooks/use-consumer-flow';
import { endGuidedJourney } from '../lib/guided-journey';
import { rememberSearchOrigin } from '../lib/search-origin';
import type { ConsumerStepProps } from './step-props';

export function ScenarioStep({ clientId }: ConsumerStepProps) {
  const { goTo, back, finish, returnTo } = useConsumerFlow(clientId);
  const care = useCareAdjustments(clientId);
  if (!care.scenario) return null;

  const handleContinue = () => {
    care.saveAdjustments();
    if (returnTo) {
      finish('review');
      return;
    }
    rememberSearchOrigin(clientId, 'scenario');
    endGuidedJourney(clientId);
    goTo('searching');
  };

  return (
    <StepFrame
      step="scenario"
      title="Here’s what your future care could look like"
      subtitle="Based on your intake and where you’d like to receive care."
      onBack={() => back('household')}
      helpLabel="Adjust these assumptions"
      helpIcon={<SlidersHorizontal />}
      help={
        <CareAdjustmentChoices
          careSetting={care.careSetting}
          onCareSettingChange={care.setCareSetting}
          adjustments={care.adjustments}
          careHoursByAmount={care.careHoursByAmount}
          familyHoursByHelp={care.familyHoursByHelp}
          onCareAmountChange={care.setCareAmount}
          onFamilyHelpChange={care.setFamilyHelp}
        />
      }
      primary={{ label: returnTo ? 'Back to your plan' : 'Continue to coverage', onClick: handleContinue }}
    >
      <CareScenarioCard scenario={care.scenario} isCustom={care.isCustom} />
    </StepFrame>
  );
}
